import { Api_routes, server_url } from '@/config/API_Routes';
import { getRequest, postRequest } from '@/config/axios-config';

const getRatnaTriggerAlerts = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getRatnaTriggerAlerts
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

const dismissRatnaAlert = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.dismissRatnaAlert,
        body
      );
      resolve(response);
    } catch (err) {
      console.error('err -- ', err);
      reject(err);
    }
  });
};

export { getRatnaTriggerAlerts, dismissRatnaAlert };
